// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3K9nB","errors":"Errors_errors__1cKNt"};